const MIN_HEIGHT_PX = 120

// Absorbs sub-pixel rounding drift between offsetHeight and rendered height at fractional
// browser zoom (e.g. 80%), which otherwise leaves the panel a hair shorter than its own
// content and triggers a needless scrollbar.
const ROUNDING_BUFFER_PX = 2

export function dropdownMaxHeightPx (naturalHeight, availableSpace) {
  const maxHeight = Math.max(MIN_HEIGHT_PX, Math.min(naturalHeight + ROUNDING_BUFFER_PX, availableSpace))
  return Math.ceil(maxHeight)
}
